import BoxInfo from '@/components/boxInfo/boxInfo';
import InformationData from '@/modules/cadastralPosition/components/informationData/informationData';
import { MoveNormalized } from '@/modules/move/entities/interfaces/move';
import React, { useMemo } from 'react';
import { Button } from 'vkit/lib/components';

interface CadastralPositionInfoProps {
  loading: boolean;
  cadastralPositionId: string;
  cadastralPosition?: MoveNormalized;
}

const CadastralPositionInfo: React.FC<CadastralPositionInfoProps> = ({
  loading,
  cadastralPositionId,
  cadastralPosition,
}) => {
  const disabledDownloadButton = useMemo(() => {
    return loading || !cadastralPositionId || !cadastralPosition?.id;
  }, [cadastralPosition?.id, cadastralPositionId, loading]);

  return (
    <BoxInfo
      title='Dados da posição cadastral'
      icon='info-outline'
      header={
        <Button
          loading={loading}
          disabled={disabledDownloadButton}
          icon='download-outline'
          label='Baixar arquivo'
          onClick={() => {
            if (cadastralPosition?.link) {
              window.open(cadastralPosition?.link, '_blank');
            }
          }}
          iconColor={disabledDownloadButton ? 'light' : 'clear'}
        />
      }>
      <InformationData data={cadastralPosition} loading={loading} />
    </BoxInfo>
  );
};

export default CadastralPositionInfo;
